/* eslint-disable no-param-reassign */
import moment from 'moment';
import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function MultiSubmitLogCard({ item, index, activeInactiveSubmitLog, downloadFile, deleteFiles, highLightId, fromDownload }) {
  const [show, setShow] = useState(false);
  const { t } = useTranslation('common');

  const displayProduct = (keyName) => {
    // Extract devOrderName values from each item
    const devOrderNames = item?.flatMap((product) => product?.[keyName]);

    // Remove duplicates
    const uniqueDevOrderNames = [...new Set(devOrderNames)];

    // Join the devOrderName values with comma separators
    const devOrderNamesString = uniqueDevOrderNames?.join(', ');

    return devOrderNamesString || '';
  };

  const productStatusMap = item.reduce((map, ele) => {
    map[ele.devOrderName] = ele.status;
    return map;
  }, {});

  const hasFiles = item?.some((log) => log?.files?.length > 0 || log?.zipFiles?.length > 0);

  return (
    // sonarlint-disable-next-line S1082
    <div
      id="accordion"
      className="col-lg-4 "
      key={index}
      onClick={() => {
        setShow(!show);
      }}
      role="button"
      tabIndex={0}
    >
      <div className={`listing-card card mt-3 ${highLightId?.toString() === item?.[0]?.reqId?.toString() ? 'active-log' : ''}`}>
        <div className="card-header d-flex align-items-center">
          <p className="py-2 px-3 m-0 font-bold">{activeInactiveSubmitLog && item?.[0]?.supplier}</p>
          <ul className="card-header-icon ml-auto">
            {item?.[0]?.message && (
              <li>
                <OverlayTrigger
                  placement={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.MULTI_SUBMIT_DOWNLOAD.BUTTON')}
                  overlay={
                    <Tooltip className="text-tooltip" id="tooltip_description">
                      {item?.[0]?.message}
                    </Tooltip>
                  }
                >
                  <button aria-label="chat" className="btn p-0" type="button">
                    <i className="icon-Chat f-18" />
                  </button>
                </OverlayTrigger>
              </li>
            )}
            {hasFiles && (
              <li>
                <button
                  className="btn p-0"
                  type="button"
                  aria-label="download"
                  title={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.MULTI_SUBMIT_DOWNLOAD.DOWNLOAD_FILE')}
                  onClick={() => downloadFile(item)}
                >
                  <i title={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.MULTI_SUBMIT_DOWNLOAD.DOWNLOAD')} className="icon-download" />
                </button>
              </li>
            )}
            <li>
              <button
                className="btn p-0"
                type="button"
                aria-label="delete"
                title={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.MULTI_SUBMIT_DOWNLOAD.DELETE')}
                onClick={() => deleteFiles(item)}
              >
                <i title={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.MULTI_SUBMIT_DOWNLOAD.DELETE')} className="icon-delete" />
              </button>
            </li>
          </ul>
        </div>
        <div className="card-body">
          {activeInactiveSubmitLog && !fromDownload ? (
            <ul className="card-ul ">
              <li>
                <strong>{t('MULTI_SUBMIT_DOWNLOAD_LOGS.BY')}: </strong>
                {item?.[0]?.sendBy}
              </li>
              <li>
                <strong>{t('MULTI_SUBMIT_DOWNLOAD_LOGS.LOG_DATE')}: </strong>
                {moment(item?.[0]?.createdAt).format('DD-MMMM-YYYY, HH:mm')}
              </li>
              <li>
                <strong>{t('MULTI_SUBMIT_DOWNLOAD_LOGS.TO')}: </strong>
                {displayProduct('sentUsers')}
              </li>
              <li>
                <strong>{t('MULTI_SUBMIT_DOWNLOAD_LOGS.CC')}: </strong>
                {displayProduct('ccMail')}
              </li>
              <li>
                <strong>{t('MULTI_SUBMIT_DOWNLOAD_LOGS.BCC')}: </strong>
                {displayProduct('bccMail')}
              </li>
              <li>
                <strong>{t('MULTI_SUBMIT_DOWNLOAD_LOGS.PRODUCT')}: </strong>
                {displayProduct('devOrderName')}
              </li>

              {show && (
                <li>
                  <strong>{t('MULTI_SUBMIT_DOWNLOAD_LOGS.FILE')}: </strong>
                  <p className="mt-1">{displayProduct('submitedModules') || ''}</p>
                </li>
              )}
            </ul>
          ) : (
            <ul className="card-ul ">
              <li>
                <strong>{t('MULTI_SUBMIT_DOWNLOAD_LOGS.DOWNLOAD')}: </strong>
                {`${item?.[0]?.downloadedBy?.firstName} ${item?.[0]?.downloadedBy?.lastName} `}
              </li>
              <li>
                <strong>{t('MULTI_SUBMIT_DOWNLOAD_LOGS.LOG_DATE')}: </strong>
                {moment(item?.[0]?.createdAt).format('DD-MMMM-YYYY, HH:mm')}
              </li>

              <li>
                <strong>{t('MULTI_SUBMIT_DOWNLOAD_LOGS.PRODUCT')}: </strong>
                {displayProduct('devOrderName')}
              </li>
              <li>
                <strong>{t('MULTI_SUBMIT_DOWNLOAD_LOGS.STATUS')}: </strong>
                {Object.entries(productStatusMap).map(([productName, status], index) => (
                  <span key={index}>
                    {productName}: <span className={`highlight-logs badge ${status === 'Completed' ? 'badge-success' : 'badge-danger'}`}>{status}</span>
                    {index < Object.entries(productStatusMap).length - 1 ? ', ' : ''}
                  </span>
                ))}
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}

export default MultiSubmitLogCard;
